/**
 * Static team profiles — no backend required.
 * 1. Add photos to: client/public/team/
 * 2. Add entries below
 */
export const teamMembers = [
  // {
  //   id: 'coach-1',
  //   name: 'Coach Name',
  //   position: 'Head Coach',
  //   description: 'Short bio.',
  //   imageUrl: '/team/coach-1.jpg',
  // },
];
